import AdminDashboard from '../../components/adminDashboard/AdminDashboard'

const Dashboard = () => {
  return <AdminDashboard />
}

export { Dashboard }
